import styled from 'styled-components';

const StyledMissing = styled.div`
  color: #888;
  font-size: 20px;
`;

const Missing = () => <StyledMissing>––</StyledMissing>;

export default Missing;
